<template>
  <div class="content">
    <!-- 搜索条件 -->
    <div class="block block-form">
      <div class="block-tilte"> 佣金明细 </div>
      <el-form :model="searchForm" class="search-form">
        <el-form-item label="事件类型">
          <el-select v-model="searchForm.type" placeholder="请选择事件类型">
            <el-option v-for="item in type_list" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="选择日期">
          <date-picker type="date" placeholder="开始日期" v-model="searchForm.createStartTime" style="width: 150px;">
        </date-picker>
          <span style="padding: 0 5px;">至</span>
          <date-picker type="date" placeholder="结束日期" v-model="searchForm.createEndTime" style="width: 150px;"></date-picker>
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button style="margin-left:12px" type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>


    <div class="block block-top">
      <Table border :columns="columns" :data="list" :loading="listLoading">
        <template slot-scope="{ row }" slot="event">
          <span>{{ nowIncomeText(row.type) }}</span>
        </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total" :current="searchForm.pageNo" show-sizer show-elevator show-total @on-change="changePage"
          @on-page-size-change="changePagesize"></Page>
      </div>
    </div>
    <detail ref='detail'></detail>
  </div>
</template>
<script>
import { getPlatformUuid } from '@/utils/auth'
import { Icon, Table, Page, Button, Select, Option, Input, DatePicker } from 'view-design'
import mingxi from '@/javaApi/mingxi.js'
import Detail from '@/components/official/TicketDetail.vue'
import { getDate } from '@/utils/date'
const mingxiModel = new mingxi()
export default {
  name: 'Mingxi',
  components: {
    Icon,
    Table,
    Page,
    Button,
    Select,
    Option,
    Input,
    DatePicker,
    Detail
  },
  data: function () {
    return {
      columns: [
        {
          title: '明细时间',
          key: 'createTimeStr'
        },
        {
          title: '事件类型',
          key: 'type',
          slot: 'event'
        },
        {
          title: '明细说明',
          key: 'orderUUID',
        },
        {
          title: '变动金额（元）',
          key: 'amountDollar'
        },
        {
          title: '变动后金额（元）',
          key: 'afterAmountDollar'
        }
      ],
      listLoading: false,
      type_list: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '订单结算'
        },
        {
          value: '2',
          label: '余额结算'
        },
        {
          value: '3',
          label: '父平台奖励金'
        },
        {
          value: '4',
          label: '订单关闭'
        },
        {
          value: '5',
          label: '官方补贴'
        },
        {
          value: '11',
          label: '购票浮动折扣佣金结算'
        }
      ],
      list: [],
      total: 0,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        type: undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        platformUUID: getPlatformUuid()
      },
      incomeTableList: {
        1: '订单结算',
        2: '余额结算',
        3: '父平台奖励',
        4: '订单关闭',
        5: '官方补贴',
        11: '购票浮动折扣佣金结算',
      }
    }
  },
  computed: {
  },
  created() {
    this.getList(true)
  },
  beforeDestroy() {
  },
  methods: {
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.pageNo = 1
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.createStartTime = getDate(searchForm.createStartTime)
      searchForm.createEndTime = getDate(searchForm.createEndTime)
      searchForm = this.formateInit(searchForm)
      if (searchForm.createStartTime) {
        searchForm.createStartTime = searchForm.createStartTime + ' 00:00:00'
      }
      if (searchForm.createEndTime) {
        searchForm.createEndTime = searchForm.createEndTime + ' 23:59:59'
      }
      let that = this
      mingxiModel.getPronfitMingxList(searchForm).then(response => {
        that.listLoading = false
        let res = response.data
        if (res.code === 200) {
          that.list = res.data.list
          that.total = res.data.total
        } else {
          let message = res.message ? res.message : '系统繁忙，请稍后再试！'
          that.$Message.error(message)
        }
      }).catch(error => {
        that.listLoading = false
        if (error != 'token invalid') {
          that.$message.error('系统繁忙，请稍后再试！')
        }
      })
    },
    nowIncomeText: function (index) {
      return this.incomeTableList[index] ? this.incomeTableList[index] : '暂无类型'
    },
    onFormReset() {

      this.searchForm.type = undefined
      this.searchForm.createStartTime = undefined
      this.searchForm.createEndTime = undefined
      this.onFormSearch()
    },
    onFormSearch() {


      this.getList(true)
    },
    changePage(value) {
      this.searchForm.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.pageNo == 1) {
        this.getList()
      }
    },
    show(index) {
      this.$refs.detail.init()
    },
    detail: function () {
      this.$refs.detail.init()
    },
    formateInit(formData) {
      let objCopy = {};
      for (let key in formData) {
        if (formData[key]) {
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
  }
}
</script>
<style scoped>
.wrapper {
  width: 100%;
  font-size: 12px;
}

.wrapper .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .table-wrapper {
  margin-top: 30px;
}

.search-wrap .ivu-icon-ios-arrow-down:before {
  color: #232323;
  content: "\F33D";
}

.ivu-date-picker-rel {
  margin: 11px 0;
}

.ivu-table {
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-radius: 2px;
}

.table-wrapper .ivu-table-header th {
  background-color: #FCFAF8 !important;
}

.table-wrapper .ivu-table-header th .ivu-table-cell {
  color: #222222 !important;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border: none;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border-radius: 0px;
  border-color: #FFFFFF !important;
}

.block-tilte {
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  margin-bottom: 24px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/official/mingxi/Index.vue